// MongoDB returns UTC datetimes without a timezone suffix by default.
// A naive ISO string must be interpreted as UTC, never as the device's local time.
const NAIVE_MONGO_UTC_ISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;

export function normalizeKd9UtcInstant(value) {
  if (typeof value === "string" && NAIVE_MONGO_UTC_ISO.test(value)) {
    return `${value}Z`;
  }
  return value;
}

export function formatKd9DateColombia(value) {
  if (!value) return "—";
  const instant = new Date(normalizeKd9UtcInstant(value));
  if (Number.isNaN(instant.getTime())) return "—";
  const shown = new Intl.DateTimeFormat("es-CO", {
    timeZone: "America/Bogota",
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true,
  }).format(instant);
  return `${shown} (Colombia)`;
}
